const loadMoreArticles = async (button) => {
  const section = button.closest('[data-more-articles]');
  const grid = section?.querySelector('[data-articles-grid]');
  const nextUrl = button.dataset.nextUrl;

  if (!section || !grid || !nextUrl) return;

  const sectionId = section.dataset.sectionId;
  const url = new URL(nextUrl, window.location.origin);
  url.searchParams.set('section_id', sectionId);

  const response = await fetch(url.toString());
  if (!response.ok) throw new Error(`Request failed with ${response.status}`);

  const markup = await response.text();
  const doc = new DOMParser().parseFromString(markup, 'text/html');
  const nextGrid = doc.querySelector('[data-articles-grid]');

  if (!nextGrid) throw new Error('No article grid in response');

  grid.append(...nextGrid.children);

  const nextButton = doc.querySelector('[data-load-more]');
  if (nextButton) {
    button.dataset.nextUrl = nextButton.dataset.nextUrl;
  } else {
    button.closest('[data-load-more-wrap]')?.remove();
  }
};

window.addEventListener('click', (e) => {
  const button = e.target.closest('[data-load-more]');
  if (!button || button.disabled) return;

  e.preventDefault();

  const label = button.querySelector('[data-load-more-label]');
  const originalLabel = label?.textContent;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (label) label.textContent = 'Loading…';

  loadMoreArticles(button)
    .catch((err) => console.error('Blog load more:', err))
    .finally(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label && originalLabel) label.textContent = originalLabel;
    });
});
